/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICCartIcon containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum cartLinesSortOrder {
    ascending = 'ascending',
    descending = 'descending'
}

export interface ICCartIconConfig extends Msdyn365.IModuleConfig {
    freeDeliveryText?: Msdyn365.RichText;
    imageSettings?: Msdyn365.IImageSettings;
    enableHoverCart?: boolean;
    cartLinesSortOrder?: cartLinesSortOrder;
    isAnonymousCheckout?: boolean;
    clientRender?: boolean;
}

export interface ICCartIconResources {
    miniCartSubTotalLabel: string;
    miniCartTotalLabel: string;
    miniCartDiscountLabel: string;
    miniCartTitle: string;
    goToCartButtonTitle: string;
    totalPriceFormatString: string;
    guestCheckoutButtonTitle: string;
    checkoutButtonTitle: string;
    productDimensionTypeColor: string;
    productDimensionTypeSize: string;
    productDimensionTypeStyle: string;
    productDimensionTypeConfiguration: string;
    quantityDisplayText: string;
    removeCartButtonText: string;
    cartLabel: string;
    cartQtyLabel: string;
    flyoutTitle: string;
    salesAgreementPricePrompt: string;
    shippingText: string;
    checkoutBlockedDueToUnavailableFundsTitle: string;
    checkoutBlockedDueToUnavailableFundsMessage: string;
}

export interface ICCartIconProps<T> extends Msdyn365.IModule<T> {
    resources: ICCartIconResources;
    config: ICCartIconConfig;
}
